<template lang="pug">
.__panel-simple
  .__panel-simple__panel
    button.__panel-simple__close(@click.prevent="$emit('close')")
    .__panel-simple__inner
      slot
</template>

<script>
import {TransitionSlideVertical} from 'elysium-common/components/transition';

export default {
  model: {
    prop: 'visible',
    event: 'close'
  },
  components: {
    TransitionSlideVertical
  },
  props: {
    visible: Boolean,
    wide: Boolean
  }
}
</script>

<style lang="scss" scoped>
.__panel-simple {
  position: absolute;
  z-index: 99999;
  bottom: 0;
  width: 100%;
  padding: 0 15px;

  &__panel {
    background-color: #fff;
    border: 2px solid #6e6bce;
    border-radius: 3px;
  }

  &__close {
    right: 15px;
    top: 15px;
    position: absolute;
  }

  &__inner {
    width: 100%;
    height: 100%;
    padding: 30px;
  }
}
</style>

<style lang="stylus" scoped>
.__panel-simple__close
  display block
  position absolute
  width 15px
  height 15px
  background-color transparent
  border-width 0
  cursor pointer
  z-index 99

  &:before,
  &:after
    position absolute
    top 6px
    left -1px
    width 17px
    height 3px
    content ''
    background-color #6e6bce
    transition background-color .3s ease

  &:before
    transform rotate(45deg)

  &:after
    transform rotate(-45deg)

  &:active,
  &:focus,
  &:hover
    outline 0

  &:hover
    &:before,
    &:after
      background-color #e25a5a

  &:active,
  &:focus
    &:before,
    &:after
      background-color: rgba(0, 0, 0, 0.85)
</style>



// WEBPACK FOOTER //
// Simple.vue?51a5de28